import React from 'react';
import {useSlotPlaceholder} from '@wix/widget-plugins-ooi';

export interface SideCartSlotProps {
  slotId: string;
  className?: string;
}

export const SlotPlaceHolderDataHook = (slotId: string) => `data-slot-${slotId}`;

export const SlotPlaceHolder = ({slotId, className}: SideCartSlotProps) => {
  const [SlotPlaceholder, isEmpty] = useSlotPlaceholder(slotId);

  return (
    <div
      data-hook={SlotPlaceHolderDataHook(slotId)}
      className={`${isEmpty ? '' : /* istanbul ignore next */ className}`}>
      <SlotPlaceholder />
    </div>
  );
};
